/**
 * Сводка для шапки: иконка X / N по видам Оборудования.
 * Цвета и состав N — по согласованной логике (не копия чипов вкладки один в один).
 */

export const HEADER_FLEET_TYPES = [
  { type: 'door', icon: 'sensor_door' },
  { type: 'panic', icon: 'emergency' },
  { type: 'nvr', icon: 'videocam' },
  { type: 'fire', icon: 'local_fire_department' },
];

/** Подписи к X/N — те же, что на вкладке Оборудование. */
export const EQUIPMENT_TYPE_HINT_KEY = {
  door: 'equipment.summary.healthHint',
  panic: 'equipment.summary.healthHint',
  nvr: 'equipment.summary.nvrHint',
  fire: 'equipment.summary.fireHint',
};

/** Якоря разделов на странице школы. Пожарка и регистратор — один блок. */
export const SCHOOL_EQUIPMENT_SECTION_ID = {
  door: 'school-equipment-doors',
  panic: 'school-equipment-panic',
  nvr: 'school-equipment-nvr',
  fire: 'school-equipment-nvr',
};

/**
 * @param {object|null|undefined} typeSummary — overview.byType[type]
 * @param {'door'|'panic'|'nvr'|'fire'} type
 * @returns {{ ok: number, problem: number, problemTone: 'critical'|'warning'|null }}
 */
export function headerStatForType(typeSummary, type) {
  const c = typeSummary?.connectivity || {};
  const r = typeSummary?.readiness || {};

  const available = Number(c.available) || 0;
  const unavailable = Number(c.unavailable) || 0;
  const notConfigured = Number(c.not_configured) || 0;
  const notReady = Number(r.not_ready) || 0;
  const ready = Number(r.ready) || 0;

  if (type === 'nvr') {
    return {
      ok: available,
      problem: unavailable,
      problemTone: unavailable > 0 ? 'critical' : null,
    };
  }

  if (type === 'fire') {
    const problem = notReady + notConfigured + unavailable;
    return {
      ok: ready,
      problem,
      problemTone: problem > 0 ? 'warning' : null,
    };
  }

  // Турникет и Тревожная станция: зелёный Доступен/На связи;
  // N = Недоступен (красный) + не готов (жёлтый), цвет худшего.
  const problem = unavailable + notReady;
  return {
    ok: available,
    problem,
    problemTone: unavailable > 0 ? 'critical' : (notReady > 0 ? 'warning' : null),
  };
}

export function headerStatsFromOverview(overview) {
  const byType = overview?.byType || {};
  return HEADER_FLEET_TYPES.map(({ type, icon }) => ({
    type,
    icon,
    ...headerStatForType(byType[type], type),
  }));
}

export function schoolByRouterIp(overview, routerIp) {
  if (!routerIp) return null;
  return (overview?.schools || []).find((row) => row.routerIp === routerIp) || null;
}
